module.exports = __webpack_public_path__ + "static/media/Bosnia and Herzegovina.9ba112bb.png";